var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    {
      staticClass: "box-card",
      staticStyle: { "margin-top": "5px" },
      attrs: { shadow: "hover" },
    },
    [
      _c(
        "div",
        { staticClass: "clearfix", attrs: { slot: "header" }, slot: "header" },
        [_c("span", [_vm._v("流转记录")])]
      ),
      _c(
        "el-steps",
        { attrs: { active: _vm.historicTaskStepNodeList.length } },
        _vm._l(_vm.historicTaskStepNodeList, function (node, index) {
          return _c("el-step", {
            key: index,
            attrs: {
              title: node.activityName,
              "finish-status": "success",
              description: node.assigneeName + node.time,
            },
          })
        }),
        1
      ),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: { size: "small", data: _vm.historicTaskList },
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "histIns.activityName",
              label: "执行环节",
              width: "180",
            },
          }),
          _c("el-table-column", {
            attrs: { prop: "assigneeName", label: "执行人", width: "180" },
          }),
          _c("el-table-column", {
            attrs: { prop: "histIns.startTime", label: "开始时间" },
          }),
          _c("el-table-column", {
            attrs: { prop: "histIns.endTime", label: "结束时间" },
          }),
          _c("el-table-column", {
            attrs: { prop: "comment.status", label: "办理状态" },
          }),
          _c("el-table-column", {
            attrs: { prop: "comment.message", label: "审批意见" },
          }),
          _c("el-table-column", {
            attrs: { prop: "durationTime", label: "任务历时" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(" " + _vm._s(scope.row.durationTime || "0秒") + " "),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }